var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMultiply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 11.85 7 8.34l-3.5 3.51-1.35-1.35L5.66 7 2.15 3.5 3.5 2.15 7 5.66l3.5-3.51 1.35 1.35L8.34 7l3.51 3.5Z"
})));
export default SvgMultiply;